import { create } from 'zustand'
import { Project, DrawingType } from '../types/project'

interface DrawingStore {
  project: Project | null
  currentDrawing: DrawingType
  mode: 'select' | 'line' | 'rect' | 'circle' | 'text'
  selectedWireType: 'power' | 'control'
  
  // Actions
  setProject: (project: Project) => void
  setCurrentDrawing: (drawing: DrawingType) => void
  setMode: (mode: DrawingStore['mode']) => void
  setSelectedWireType: (type: 'power' | 'control') => void
  updateProject: (updates: Partial<Project>) => void
}

export const useDrawingStore = create<DrawingStore>((set) => ({
  project: null,
  currentDrawing: 'plan',
  mode: 'select',
  selectedWireType: 'power',
  
  setProject: (project) => set({ project }),
  setCurrentDrawing: (drawing) => set({ currentDrawing: drawing }),
  setMode: (mode) => set({ mode }),
  setSelectedWireType: (type) => set({ selectedWireType: type }),
  updateProject: (updates) => set((state) => ({
    project: state.project ? { ...state.project, ...updates } : null
  })),
}))
